const requestedByClientId = new Set<number>();

export const requestProfileOverviewOnce = (clientId: number, request: () => void): void => {
    if (requestedByClientId.has(clientId)) return;
    requestedByClientId.add(clientId);
    request();
};
